"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var CreditCardBrands_1 = require("../../../../../../../common/enum/CreditCardBrands");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var MasterCardLogo_1 = require("../../../../../../../common/assets/creditCardLogos/MasterCardLogo");
var VisaLogoMulti_1 = require("../../../../../../../common/assets/creditCardLogos/VisaLogoMulti");
var react_intl_1 = require("react-intl");
var PaymentFailedMessage = function (_a) {
    var _b;
    var style = _a.style, paymentInfo = _a.paymentInfo;
    var _c, _d;
    var transactionDateLabel = paymentInfo
        ? date_fns_1.format(new Date(parseInt((_c = paymentInfo) === null || _c === void 0 ? void 0 : _c.transactionTime)), 'dd/MMM/yyyy hh:mm aa')
        : '';
    var intl = react_intl_1.useIntl();
    var cardBrands = (_b = {},
        _b[CreditCardBrands_1.CreditCardBrands.VISA] = <VisaLogoMulti_1.default className={style.cardLogo}/>,
        _b[CreditCardBrands_1.CreditCardBrands.MASTERCARD] = <MasterCardLogo_1.default />,
        _b);
    var cardBrand = cardBrands[(_d = paymentInfo) === null || _d === void 0 ? void 0 : _d.brand] || null;
    if (!paymentInfo) {
        return null;
    }
    return (<>
      <core_1.Typography component="h2" variant="h4" data-test="text:paymentError:subTitle" className={style.subTitle}>
        <Translation_1.default id="trans__checkout__payment_page__failed_subtitle"/>
      </core_1.Typography>
      <core_1.Typography component="div" variant="body1" data-test="payment_page:payment_error:description1" className={style.paymentDescriptionContainer}>
        <Translation_1.default className={style.paymentDescription} id="trans__checkout__payment_page__failed_description1" values={{
        card_brand_image: cardBrand,
        card_number: paymentInfo.card,
        transaction_id: paymentInfo.transactionId,
        current_date: transactionDateLabel,
        reason_rejection: paymentInfo.actionDescription,
        mobile_phone: (<a data-test="payment_page:payment_error:phone" href={"tel:" + intl.formatMessage({ id: 'trans__checkout__payment_page__phone_in_description' })}>
                <Translation_1.default id="trans__checkout__payment_page__phone_in_description"/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = PaymentFailedMessage;
